<template>
  <div class="d-flex justify-content-stretch align-items-center">
    <div class="logo d-flex justify-content-center align-items-center flex-shrink-0">
      <span>{{ markerText }}</span>
    </div>
    <div class="details d-flex flex-column justfy-content-center align-items-start flex-grow-1 p-2">
      <span class="h5 mb-0 text-bold">{{ parkingSpace.name }}</span>
      <span class="text-muted text-xxs text-uppercase"
        >{{ description }}{{ parkingSpace.updatedAt | date("H:mm") }}</span
      >
    </div>
    <div
      v-if="occupancyKnown"
      class="occupancy d-flex flex-column justfy-content-center align-items-end"
    >
      <span class="h6 text-bold m-0"
        >{{ parkingSpace.capacity - parkingSpace.occupancy }} {{ t.free }}</span
      >
      <span class="text-xxs text-muted text-uppercase">{{ t.of }} {{ parkingSpace.capacity }}</span>
    </div>
    <div v-if="occupancyKnown" class="d-flex ml-1">
      <div
        v-for="i in amountIndicators"
        :class="{ green: indicatorIsGreen(i), red: !indicatorIsGreen(i) }"
        :key="`indicator-${i}`"
        class="indicator"
      ></div>
    </div>
    <div v-else class="d-none d-sm-flex text-xs text-muted text-right">
      {{ t.unknown_occupancy }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ParkingSpaceListItem",
  props: {
    markerText: {
      type: String,
      default: "P",
    },
    t: {
      type: Object,
      default: () => ({}),
    },
    parkingSpace: {
      type: Object,
      required: true,
    },
    distance: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      amountIndicators: 5,
    };
  },
  computed: {
    occupancyKnown() {
      return this.parkingSpace.occupancy !== null && this.parkingSpace.capacity !== null;
    },
    description() {
      return `${this.distance ? this.distance + " " + this.t.distance + ", " : ""}${this.t.last}: `;
    },
    percentOccupied() {
      return this.parkingSpace.occupancy / this.parkingSpace.capacity;
    },
  },
  methods: {
    indicatorIsGreen(index) {
      return this.percentOccupied <= (1 / this.amountIndicators) * index;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.logo {
  background: #017cc0;
  color: $white;
  font-size: $h4-font-size;
  font-weight: $font-weight-bold;
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

.text-xxs {
  font-size: $font-size-xxs;
}

.indicator {
  width: 3px;
  height: 20px;
  margin-left: 2px;
  border-radius: 2px;

  &.red {
    background: $danger;
  }

  &.green {
    background: $success;
  }
}
</style>
